import { Component, input } from '@angular/core';
import { NavTileComponent } from '../nav-tile/nav-tile.component';
import { NavTile } from './nav-tile-grid.model';

@Component({
    selector: 'app-nav-tile-grid',
    templateUrl: './nav-tile-grid.component.html',
    imports: [NavTileComponent],
    host: {
        class: 'w-full'
    }
})
export class NavTileGridComponent {
    public tiles = input.required<NavTile[]>();
}
